export default "__VITE_ASSET__DOtWpgfZ__"